<div [class]="isLoading ? 'page-loader' : 'page-loder d-none'"></div>
<div id="trade-register-form">
  <div class="modal-header">
    <h4 class="modal-title">Storage Fee</h4>
  </div>
  <div class="modal-body">
    <div class="modal-body-inner">
      <div class="add-user-form">
        <div class="row">
          <div class="col">
            @if (isInitialized) {
              @for (delivery of deliveries; track delivery.id) {
                <div class="d-flex justify-content-between align-items-center storage-fee-delivery-row">
                  <span class="delivery-code-label">{{ delivery.delivery_code }}</span>
                  <label class="checkbox-item storage-fee-gold mb-0" [class.cursor-not-allowed]="delivery.isDelivered">
                    <input type="checkbox"
                      [(ngModel)]="delivery.is_consider_for_storage_fees"
                      [disabled]="delivery.isDelivered" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="dark-bordered-btn dont-send-btn" data-dismiss="modal" (click)="cancel()">Cancel</button>
    <button type="button" class="submit-btn-grey status-modal-save" (click)="onUpdate()">Update</button>
  </div>
</div>
